class LookbookManager extends ModuleManager{
    
    constructor(options = {}) {
        super();
        this.modals = document.querySelectorAll('.lookbook-modal')
        this.openers = document.querySelectorAll('.modal-opener')
        this.closers = document.querySelectorAll('.modal-closer')

        // Elements
        
        
        // Initialise
        this.add_listeners();
    }


    // [element, event_name, handler_function, (optional) once_boolean]
    // [this.my_button, 'click', this.handle_button_click]
    define_listeners () {

        const singles = [
           
        ]
        const collections = [
            [this.openers, 'click', this.openModal],
            [this.closers, 'click', this.closeAllModals],
        ]

        return { singles, collections };

    }
    openModal(e){
        const trigger = e.currentTarget.closest('.modal-opener')
        const modal = document.querySelector(`#${trigger.dataset.modal}`)
        if (modal) {
            modal.classList.add('open')
        }
        const slide = trigger.dataset.slide
        if(slide){
            const slideEvent = new CustomEvent('modal:open-to-slide', {bubbles: true,detail: {slide: slide,}});
            modal.dispatchEvent(slideEvent);
        }
    }

    closeAllModals () {
        this.modals.forEach((modal)=>{modal.classList.remove('open')})
    }
};

